/** *********************************************
  Action creators that produces actions for users reducer
********************************************** */
import actionTypes from './actionTypes';
import { fetchUser } from './apiRequests';

export const fetchProfileSuccess = (profile) => ({
  type: actionTypes.FETCH_PROFILE_SUCCESS,
  profile,
});

export const fetchProfileError = (error) => ({
  type: actionTypes.FETCH_PROFILE_ERROR,
  error,
});

export const fetchProfile = (id) => {
  return (dispatch) => {
    return fetchUser(id)
      .then((profile) => dispatch(fetchProfileSuccess(profile)))
      .catch((error) => dispatch(fetchProfileError(error)));
  };
};



// WEBPACK FOOTER //
// src/actions/profile/actionCreators.js